<template>
  <div id="menu">
    <div class="container">
      <Title :text="title"></Title>

      <div class="menu-content">
        <div class="menuSwiper swiper-container" id="swiper-menu">
          <div class="swiper-wrapper">
            <div class="swiper-slide item">
              <div class="row">
                <div class="img wow fadeIn" >
                  <img src="../../../assets/img/menu/menu.jpg" alt />
                </div>
                <div class="text">
                  <div class="title">Authenic Chinese Dishes</div>
                  <div class="menu-content">
                    <table>
                      <tr>
                        <td>Moo Goo Gai Pan</td>

                        <td>$7.75</td>
                      </tr>
                      <tr>
                        <td>Chicken with Cashew Nuts</td>

                        <td>$7.75</td>
                      </tr>
                      <tr>
                        <td>Sweet and Sour Chicken</td>

                        <td>$7.75</td>
                      </tr>
                    </table>
                  </div>

                  <!-- <div class="more" @click="pickup">more+</div> -->

                  <div class="btn" @click="delivery">ORDER NOW</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="swiper-container" id="swiper-thumbs">
          <div class="swiper-wrapper">
            <div class="swiper-slide wow slideInLeft" data-wow-delay=".4s">
              <img src="../../../assets/img/menu/menu (1).jpg" alt />
            </div>

            <div class="swiper-slide wow slideInDown" data-wow-delay=".5s">
              <img src="../../../assets/img/menu/menu (2).jpg" alt />
            </div>

            <div class="swiper-slide wow slide" data-wow-delay=".6s">
              <img src="../../../assets/img/menu/menu (3).jpg" alt />
            </div>

            <div class="swiper-slide wow slideInRight" data-wow-delay=".7s">
              <img src="../../../assets/img/menu/menu (4).jpg" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "../title/Title2.vue";
import Swiper from "swiper";
import WOW from 'wowjs'   

export default {
  name: "Menu",
  props: {},
  data() {
    return {
      title: "Menu",
      thumbsSwiper: {}
    };
  },
  components: {
    Title
  },
  methods: {
   delivery() {
      window.open("https://us.orderspoon.com/peking-chinese-restaurant")
    },
  },
  mounted() {
     new WOW.WOW().init()
    this.thumbsSwiper = new Swiper("#swiper-thumbs", {
      spaceBetween: 10,
      slidesPerView: 4,
      watchSlidesVisibility: true, //防止不可点击
      mousewheel: true,
      loop: true,
      autoplay: {
        delay: 6000,
        stopOnLastSlide: false,
        disableOnInteraction: true
      }
    });
    new Swiper("#swiper-menu", {
      spaceBetween: 10,
      thumbs: {
        swiper: this.thumbsSwiper
      }
    });
  }
};
</script>

<style scoped lang="scss">
#menu {
  background: url("../../../assets/img/menu/menu_bg.jpg") no-repeat;
  background-size: 100% 100%;
  background-position: center;
}

.menuSwiper {
  max-height: 15.151515rem;
  border-radius: 0.606061rem;
  margin-bottom: 0.606061rem;
  box-shadow: 0 0 0.060606rem rgba($color: #fff, $alpha: 0.6);
  background: #fff;
  .item {
    .row {
      display: flex;
      flex-flow: row nowrap;

      .img {
        flex: 60%;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .text {
        flex: 40%;

        .title {
          font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
          font-size: 0.969697rem;
          color: #f4a702;
          text-align: center;
          margin-top: 2.424242rem;
          text-transform: uppercase;
          @media screen and (max-width: 799px) {
            margin-top: 0.5rem;
          }
        }

        .more {
          text-align: center;
          font-size: 0.484848rem;
          font-family: Arial, Helvetica, sans-serif;
          color: #999999;
          padding-top: 0.5rem;
          cursor: pointer;
        }

        .menu-content {
          table {
            width: 100%;
            font-family: Arial, Helvetica, sans-serif;
            font-size: 0.606061rem;
            margin-top: 1.060606rem;
            @media screen and (max-width: 799px) {
              margin-top: 0.5rem;
            }

            td {
              padding-top: 0.909091rem;
              text-indent: 0.606061rem;
            }
          }
        }

        .btn {
          border: 2px solid #f4a702;
          text-align: center;
          width: 7.878788rem;
          height: 1.818182rem;
          line-height: 1.818182rem;
          font-size: 0.848485rem;
          margin: 1.212121rem auto;
          color: #f4a702;
          border-radius: 0.909091rem;
          cursor: pointer;
        }
      }
    }
  }
}

#swiper-thumbs {
  img {
    cursor: pointer;
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
}
</style>
